import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { redirectGuard } from './shared/guards/redirect.guard';
import { PageNotFoundComponent } from './views/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [redirectGuard],
    children: [],
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthO3RoutingModule {}
